export const pokedexGen1 = {
  "pokedex1": "Bisasam",
  "pokedex2": "Bisaknosp",
  "pokedex3": "Bisaflor",
  "pokedex4": "Glumanda",
  "pokedex5": "Glutexo",
  "pokedex6": "Glurak",
  "pokedex7": "Schiggy",
  "pokedex8": "Schillok",
  "pokedex9": "Turtok",
  "pokedex10": "Raupy",
  "pokedex11": "Safcon",
  "pokedex12": "Smettbo",
  "pokedex13": "Hornliu",
  "pokedex14": "Kokuna",
  "pokedex15": "Bibor",
  "pokedex16": "Taubsi",
  "pokedex17": "Tauboga",
  "pokedex18": "Tauboss",
  "pokedex19": "Rattfratz",
  "pokedex20": "Rattikarl",
  "pokedex21": "Habitak",
  "pokedex22": "Ibitak",
  "pokedex23": "Rettan",
  "pokedex24": "Arbok",
  "pokedex25": "Pikachu",
  "pokedex26": "Raichu",
  "pokedex27": "Sandan",
  "pokedex28": "Sandamer",
  "pokedex29": "Nidoran♀",
  "pokedex30": "Nidorina",
  "pokedex31": "Nidoqueen",
  "pokedex32": "Nidoran♂",
  "pokedex33": "Nidorino",
  "pokedex34": "Nidoking",
  "pokedex35": "Piepi",
  "pokedex36": "Pixi",
  "pokedex37": "Vulpix",
  "pokedex38": "Vulnona",
  "pokedex39": "Pummeluff",
  "pokedex40": "Knuddeluff",
  "pokedex41": "Zubat",
  "pokedex42": "Golbat",
  "pokedex43": "Myrapla",
  "pokedex44": "Duflor",
  "pokedex45": "Giflor",
  "pokedex46": "Paras",
  "pokedex47": "Parasek",
  "pokedex48": "Bluzuk",
  "pokedex49": "Omot",
  "pokedex50": "Digda",
  "pokedex51": "Digdri",
  "pokedex52": "Mauzi",
  "pokedex53": "Snobilikat",
  "pokedex54": "Enton",
  "pokedex55": "Entoron",
  "pokedex56": "Menki",
  "pokedex57": "Rasaff",
  "pokedex58": "Fukano",
  "pokedex59": "Arkani",
  "pokedex60": "Quapsel",
  "pokedex61": "Quaputzi",
  "pokedex62": "Quappo",
  "pokedex63": "Abra",
  "pokedex64": "Kadabra",
  "pokedex65": "Simsala",
  "pokedex66": "Machollo",
  "pokedex67": "Maschock",
  "pokedex68": "Machomei",
  "pokedex69": "Knofensa",
  "pokedex70": "Ultrigaria",
  "pokedex71": "Sarzenia",
  "pokedex72": "Tentacha",
  "pokedex73": "Tentoxa",
  "pokedex74": "Kleinstein",
  "pokedex75": "Georok",
  "pokedex76": "Geowaz",
  "pokedex77": "Ponita",
  "pokedex78": "Gallopa",
  "pokedex79": "Flegmon",
  "pokedex80": "Lahmus",
  "pokedex81": "Magnetilo",
  "pokedex82": "Magneton",
  "pokedex83": "Porenta",
  "pokedex84": "Dodu",
  "pokedex85": "Dodri",
  "pokedex86": "Jurob",
  "pokedex87": "Jugong",
  "pokedex88": "Sleima",
  "pokedex89": "Sleimok",
  "pokedex90": "Muschas",
  "pokedex91": "Austos",
  "pokedex92": "Nebulak",
  "pokedex93": "Alpollo",
  "pokedex94": "Gengar",
  "pokedex95": "Onix",
  "pokedex96": "Traumato",
  "pokedex97": "Hypno",
  "pokedex98": "Krabby",
  "pokedex99": "Kingler",
  "pokedex100": "Voltobal",
  "pokedex101": "Lektrobal",
  "pokedex102": "Owei",
  "pokedex103": "Kokowei",
  "pokedex104": "Tragosso",
  "pokedex105": "Knogga",
  "pokedex106": "Kicklee",
  "pokedex107": "Nockchan",
  "pokedex108": "Schlurp",
  "pokedex109": "Smogon",
  "pokedex110": "Smogmog",
  "pokedex111": "Rihorn",
  "pokedex112": "Rizeros",
  "pokedex113": "Chaneira",
  "pokedex114": "Tangela",
  "pokedex115": "Kangama",
  "pokedex116": "Seeper",
  "pokedex117": "Seemon",
  "pokedex118": "Goldini",
  "pokedex119": "Golking",
  "pokedex120": "Sterndu",
  "pokedex121": "Starmie",
  "pokedex122": "Pantimos",
  "pokedex123": "Sichlor",
  "pokedex124": "Rossana",
  "pokedex125": "Elektek",
  "pokedex126": "Magmar",
  "pokedex127": "Pinsir",
  "pokedex128": "Tauros",
  "pokedex129": "Karpador",
  "pokedex130": "Garados",
  "pokedex131": "Lapras",
  "pokedex132": "Ditto",
  "pokedex133": "Evoli",
  "pokedex134": "Aquana",
  "pokedex135": "Blitza",
  "pokedex136": "Flamara",
  "pokedex137": "Porygon",
  "pokedex138": "Amonitas",
  "pokedex139": "Amoroso",
  "pokedex140": "Kabuto",
  "pokedex141": "Kabutops",
  "pokedex142": "Aerodactyl",
  "pokedex143": "Relaxo",
  "pokedex144": "Arktos",
  "pokedex145": "Zapdos",
  "pokedex146": "Lavados",
  "pokedex147": "Dratini",
  "pokedex148": "Dragonir",
  "pokedex149": "Dragoran",
  "pokedex150": "Mewtu",
  "pokedex151": "Mew"
};